.stats {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 1rem;
  background-color: var(--tg-theme-secondary-bg-color);

  &__header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;

    h2 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
    }
  }

  &__modes {
    display: flex;
    gap: 0.2rem;
    padding: 0.2rem;
    border-radius: 0.65rem;
    background-color: var(--tg-theme-bg-color);

    // nested for specificity over the Btn wrapper design resets
    .stats__mode {
      padding: 0.25rem 0.75rem;
      border-radius: 0.5rem;
      font-size: 0.85rem;
      color: var(--tg-theme-subtitle-text-color);

      &_active {
        color: var(--tg-theme-button-text-color);
        background-color: var(--tg-theme-button-color);

        &:hover {
          opacity: 1;
        }

        // !important + higher specificity to beat the .btn_wrapper:active resets
        &:active {
          color: var(--tg-theme-button-text-color) !important;
          background-color: var(--tg-theme-button-color) !important;
        }
      }
    }
  }

  &__metrics {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  &__controls {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  &__empty {
    margin: 0;
    padding: 2rem 0;
    text-align: center;
    color: var(--tg-theme-subtitle-text-color);
  }

  //
  //

  // chips shared by the metrics and controls rows; nested for specificity over the Btn wrapper design resets
  .chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.25rem 0.75rem;
    border: 1px solid var(--tg-theme-subtitle-text-color);
    border-radius: 1rem;
    font-size: 0.85rem;
    color: var(--tg-theme-subtitle-text-color);

    &__dot {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
    }

    &_active {
      border-color: var(--tg-theme-button-color);
      color: var(--tg-theme-button-text-color);
      background-color: var(--tg-theme-button-color);

      &:hover {
        opacity: 1;
      }

      // !important + higher specificity to beat the .btn_wrapper:active resets
      &:active {
        color: var(--tg-theme-button-text-color) !important;
        border-color: var(--tg-theme-button-color) !important;
        background-color: var(--tg-theme-button-color) !important;
      }
    }
  }
}

//
//

.totals {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.25rem;
  font-size: 0.9rem;

  &__item {
    display: flex;
    align-items: center;
    gap: 0.4rem;

    i {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
    }
  }
}
